import { render } from "./Transport.vue?vue&type=template&id=638c69d1&scoped=true"
import script from "./Transport.vue?vue&type=script&lang=js"
export * from "./Transport.vue?vue&type=script&lang=js"

import "./Transport.vue?vue&type=style&index=0&id=638c69d1&scoped=true&lang=css"
import "./Transport.vue?vue&type=style&index=1&id=638c69d1&lang=css"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/CERAMICAS/mi-stock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638c69d1"]])

export default __exports__